import EditorRoutes from 'foundation/EditorRoutes';
import {ASSAY_TYPES} from 'results/assay-schemas/AssaySchemaConstants';
import {RouteBundle} from 'routing/RouteConstants';

export const ResultsRoutes: RouteBundle = {
  domain: 'results',
  routes: [
    {
      urlPattern: 'assay-schemas/requests/',
      handler: EditorRoutes.requestSchemas.bind(EditorRoutes),
    },
    {
      urlPattern: 'assay-schemas/requests/create',
      handler: EditorRoutes.requestSchemasCreate.bind(EditorRoutes),
    },
    {
      urlPattern: 'assay-schemas/requests/:assaySchemaId',
      handler: requestSchemaById,
    },
    {urlPattern: 'assay-schemas/results/', handler: assayResultSchemas},
    {
      urlPattern: 'assay-schemas/results/create',
      handler: EditorRoutes.resultSchemaCreate.bind(EditorRoutes),
    },
    {
      urlPattern: 'assay-schemas/results/:assaySchemaId',
      handler: resultSchemaById,
    },
    {
      urlPattern: 'assay-schemas/results/json/create',
      handler: assayResultSchemaCreateJson,
    },
    {
      urlPattern: 'assay-schemas/results/json/:assaySchemaId',
      handler: resultSchemaJsonById,
    },
    {urlPattern: 'assay-schemas/runs/', handler: assayRunSchemas},
    {
      urlPattern: 'assay-schemas/runs/create',
      handler: EditorRoutes.runSchemasCreate.bind(EditorRoutes),
    },
    {
      urlPattern: 'assay-schemas/runs/:assaySchemaId',
      handler: runSchemaById,
    },
    {
      urlPattern: 'assay-schemas/runs/json/create',
      handler: assayRunSchemasCreateJson,
    },
    {
      urlPattern: 'assay-schemas/runs/json/:assaySchemaId',
      handler: runSchemaJsonById,
    },

    // Legacy handle-prefixed routes (redirect server-side, but still needed for client-side navigation)
    {
      urlPattern: ':currentUserUrl/assay-schemas/requests/',
      handler: EditorRoutes.requestSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/requests/create',
      handler: EditorRoutes.requestSchemasCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/requests/:assaySchemaId',
      handler: EditorRoutes.requestSchema.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: ':currentUserUrl/assay-schemas/results/', handler: assayResultSchemas, legacy: true},
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/create',
      handler: EditorRoutes.resultSchemaCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/:assaySchemaId',
      handler: EditorRoutes.resultSchema.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/json/create',
      handler: assayResultSchemaCreateJson,
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/json/:assaySchemaId',
      handler: assayResultSchemaJson,
      legacy: true,
    },
    {urlPattern: ':currentUserUrl/assay-schemas/runs/', handler: assayRunSchemas, legacy: true},
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/create',
      handler: EditorRoutes.runSchemasCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/:assaySchemaId',
      handler: EditorRoutes.runSchema.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/json/create',
      handler: assayRunSchemasCreateJson,
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/json/:assaySchemaId',
      handler: assayRunSchemaJson,
      legacy: true,
    },
  ],
};

function requestSchemaById(assaySchemaId: string): void {
  EditorRoutes.requestSchema('', assaySchemaId);
}

function resultSchemaById(assaySchemaId: string): void {
  EditorRoutes.resultSchema('', assaySchemaId);
}

function resultSchemaJsonById(assaySchemaId: string): void {
  EditorRoutes.assaySchema(ASSAY_TYPES.ASSAY_RESULT, '', assaySchemaId);
}

function runSchemaById(assaySchemaId: string): void {
  EditorRoutes.runSchema('', assaySchemaId);
}

function runSchemaJsonById(assaySchemaId: string): void {
  EditorRoutes.assaySchema(ASSAY_TYPES.ASSAY_RUN, '', assaySchemaId);
}

function assayResultSchemas(): void {
  EditorRoutes.assaySchemas(ASSAY_TYPES.ASSAY_RESULT);
}

function assayResultSchemaCreateJson(): void {
  EditorRoutes.assaySchemasCreate(ASSAY_TYPES.ASSAY_RESULT);
}

function assayResultSchemaJson(ownerUrlId: string, resultSchemaId: string): void {
  EditorRoutes.assaySchema(ASSAY_TYPES.ASSAY_RESULT, ownerUrlId, resultSchemaId);
}

function assayRunSchemas(): void {
  EditorRoutes.assaySchemas(ASSAY_TYPES.ASSAY_RUN);
}

function assayRunSchemasCreateJson(): void {
  EditorRoutes.assaySchemasCreate(ASSAY_TYPES.ASSAY_RUN);
}

function assayRunSchemaJson(ownerUrlId: string, runSchemaId: string): void {
  EditorRoutes.assaySchema(ASSAY_TYPES.ASSAY_RUN, ownerUrlId, runSchemaId);
}
